module.exports = __webpack_public_path__ + "img/support_a14.5443707f.png";